// @ts-strict-ignore
import { GetCollectionsShowResponse } from 'mytours-read-api-typescript'
import { ionHistory } from '.'

interface SectionQueryParams {
	storySectionId?: number
	sectionItemId?: number
}
export const getSectionsQueryParams = (): SectionQueryParams => {
	const searchParams = new URLSearchParams(window.location.search)
	const storySectionId = Number(searchParams.get('story-section')) || undefined
	const sectionItemId = Number(searchParams.get('section-item-id')) || undefined

	return { storySectionId, sectionItemId }
}

export const deleteSectionsQueryParams = (): void => {
	const searchParams = new URLSearchParams(window.location.search)

	const queryBeforeDelete = searchParams.toString()

	searchParams.delete('story-section')
	searchParams.delete('section-item-id')

	const query = searchParams.toString()

	if (queryBeforeDelete !== query) {
		ionHistory.replace(window.location.pathname + (query ? '?' + query : '') + window.location.hash)
	}
}

interface MapQueryParams {
	showDetailsModal?: boolean
	collectionItemId?: number
	showDetailsModalExist?: boolean
}
export const getMapQueryParams = (): MapQueryParams => {
	const searchParams = new URLSearchParams(window.location.search)
	const showDetailsModal = searchParams.get('show-detail-modal') === 'true'
	const collectionItemId = Number(searchParams.get('collection-item-id')) || undefined
	const showDetailsModalExist = Boolean(searchParams.get('show-detail-modal'))

	return { showDetailsModal, collectionItemId, showDetailsModalExist }
}

export const replaceMapQueryParams = (
	showModal: boolean,
	subtype: GetCollectionsShowResponse.SubtypeEnum,
	itemId?: number,
): void => {
	const searchParams = new URLSearchParams(window.location.search)

	const queryBeforeDelete = searchParams.toString()

	if (showModal) {
		const showDetailModal = searchParams.has('show-detail-modal')
		if (!showDetailModal) {
			searchParams.append('show-detail-modal', 'true')
		}

		if (subtype !== GetCollectionsShowResponse.SubtypeEnum.CollectionTour) {
			const collectionItemId = searchParams.has('collection-item-id')
			if (!collectionItemId) {
				searchParams.append('collection-item-id', String(itemId))
			}
		}
	} else {
		searchParams.delete('show-detail-modal')

		if (subtype !== GetCollectionsShowResponse.SubtypeEnum.CollectionTour) {
			searchParams.delete('collection-item-id')
		}
	}

	const query = searchParams.toString()

	if (queryBeforeDelete !== query) {
		ionHistory.replace(window.location.pathname + (query ? '?' + query : '') + window.location.hash)
	}
}

export const addQueryParam = (name: string, value: string | number | boolean): void => {
	const searchParams = new URLSearchParams(window.location.search)

	const queryBeforeDelete = searchParams.toString()

	const exist = searchParams.has(name)
	if (exist) {
		searchParams.delete(name)
	}

	searchParams.append(name, String(value))

	const query = searchParams.toString()

	if (queryBeforeDelete !== query) {
		ionHistory.replace(window.location.pathname + (query ? '?' + query : '') + window.location.hash)
	}
}

export const removeQueryParam = (name: string): void => {
	const searchParams = new URLSearchParams(window.location.search)

	const queryBeforeDelete = searchParams.toString()

	searchParams.delete(name)

	const query = searchParams.toString()

	if (queryBeforeDelete !== query) {
		ionHistory.replace(window.location.pathname + (query ? '?' + query : '') + window.location.hash)
	}
}

export const getQueryParam = (name: string): string => {
	const searchParams = new URLSearchParams(window.location.search)

	return searchParams.get(name)
}
